import { axiosMaximus } from './axiosMaximus';
import { makeConfig, makeUrl } from './basicHelpers';

export const basicRequestGet = async (relativeUrl: string, requestConfig = {}) => {
  try {
    return await axiosMaximus.get(makeUrl(relativeUrl), makeConfig(requestConfig));
  } catch (error) {
    // @ts-ignore
    delete error.stack;
    throw error;
  }
};
